type SchedulableTask = {
  start: Date;
  end: Date;
};

/**
 * Returns a two-dimensional array.
 * First dimension represents the resource to process the task.
 * The second dimension represents the tasks to be processed by the resource.
 *
 * Pseudo code:
 * - Sort tasks by start date
 * - Create a two-dimensional array
 * - Iterate over the tasks
 *   - If the task can be processed by the resource, add it to the resource's array
 *   - If the task can't be processed by the resource, create a new resource and add the task to the resource's array
 * - Return the two-dimensional array
 *
 * @param tasks tasks to be scheduled
 */
export const scheduleTasks = <T extends SchedulableTask>(tasks: T[]): T[][] => {
  const sortedTasks = tasks.sort(
    (a, b) => a.start.getTime() - b.start.getTime()
  );

  const taskSchedules: T[][] = [];

  sortedTasks.forEach((task) => {
    let taskScheduled = false;
    for (const schedule of taskSchedules) {
      const lastTask = schedule[schedule.length - 1];
      if (lastTask.end.getTime() <= task.start.getTime()) {
        schedule.push(task);
        taskScheduled = true;
        break;
      }
    }
    if (!taskScheduled) {
      taskSchedules.push([task]);
    }
  });

  return taskSchedules;
};
